@if(visible){
<div class="window-backdrop" [class.backdrop-disabled]="!blockBackground">
  <div class="window" [ngClass]="{ 'collapsed': isCollapsed, 'transparent': isTransparent }" [ngStyle]="styles">
    <div class="window-header">
      <span class="window-title">{{ title }}</span>
      <div class="window-controls">
        @if(showTransparency){
        <button (click)="toggleTransparency()">
          {{ isTransparent ? '○' : '●' }}
        </button>}
        @if(showHide){<button (click)="toggleCollapse()">
          {{ isCollapsed ? '▔' : '_' }}
        </button>}
        @if(showClose){<button [disabled]="closeDisabled" (click)="onClose()">
          @if(closeDisabled){
          <div class="molv-spinner small"></div>
          } @else {
            <img src="assets/icons/molv-close.svg" class="molv-close-icon">
          }
        </button>}
      </div>
    </div>

    <div class="window-content">
      <ng-content></ng-content>
    </div>

  </div>
</div>
}